import "@app/styles/error-page.css";

import TMLogo from "@assets/tm_logo.webp";
import useRemoveOverlay from "@hooks/useRemoveOverlay";
import type { ReactElement } from "react";
import { Link } from "react-router";

type Props = Readonly<{
  message?: string;
}>;

const DEFAULT_MESSAGE = "Server Error!";

export default function ErrorPage({
  message = DEFAULT_MESSAGE,
}: Props): ReactElement {
  useRemoveOverlay();
  return (
    <>
      <div className="error-page">
        <div id="container">
          <div className="white-container">
            <div className="text-center m-auto">
              <h1>
                <img
                  src={TMLogo}
                  className="logo center img-responsive"
                  alt="Tamil Murasu"
                />
              </h1>
            </div>
            <p className="font-sans font-24">
              <strong>அன்புள்ள வாசகரே,</strong>
            </p>
            <p className="font-sans font-18" title={message}>
              தொழில்நுட்பச் சிக்கல்களை எதிர்கொண்டுவருவதால் ஏற்பட்டுள்ள
              இடையூறுக்கு வருந்துகிறோம்.சிக்கலை விரைவில் சரிசெய்யும் பணியில்
              நாங்கள் ஈடுபட்டுள்ளதால் சற்று பொறுத்துக்கொள்ள வேண்டுகிறோம்.
              <br />
              அண்மைய செய்திகளுக்கு எங்கள் சமூக ஊடகப் பக்கங்களுடன்
              இணைந்திருங்கள்: <br />
              <br />
              <Link
                to="https://www.facebook.com/tamilmurasu/"
                target="_blank"
                rel="noreferrer"
              >
                - ஃபேஸ்புக்{" "}
              </Link>
              <br />
              <Link
                to="https://www.instagram.com/tamil_murasu/"
                target="_blank"
                rel="noreferrer"
              >
                - இன்ஸ்டகிராம்{" "}
              </Link>
              <br />
              <Link
                to="https://www.youtube.com/@Tamil_Murasu"
                target="_blank"
                rel="noreferrer"
              >
                - யூடியூப்{" "}
              </Link>
              <br />
              <Link
                to="https://www.tiktok.com/@tamilmurasu_sg"
                target="_blank"
                rel="noreferrer"
              >
                - டிக்டாக்{" "}
              </Link>
              <br />
              <Link
                to="https://whatsapp.com/channel/0029VadVjPV8fewnqkhfPd2X"
                target="_blank"
                rel="noreferrer"
              >
                - வாட்ஸ்அப்{" "}
              </Link>
              <br />
              <Link
                to="https://t.me/tamilmurasu"
                target="_blank"
                rel="noreferrer"
              >
                - டெலிகிராம்{" "}
              </Link>
              <br />
              <br />
              உதவி தேவைப்பட்டால்,{" "}
              <Link to="mailto:circs@sph.com.sg">circs@sph.com.sg</Link> என்ற
              மின்னஞ்சல் அல்லது <Link to="callto:63883838">6388 3838</Link>{" "}
              (திங்கள்-வெள்ளி: காலை 8.30 மணி - மாலை 6 மணி, சனி-ஞாயிறு: காலை 8.30
              மணி - நண்பகல் 12 மணி) என்ற அழைப்பு எண் வழியாக எங்கள் வாடிக்கையாளர்
              சேவைக் குழுவைத் தொடர்புகொள்ளுங்கள். பொறுமையுடன் காத்திருப்பதற்கு
              நன்றி!
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
